import React from 'react';
/**
 * Don't use this component as icon, use TagSvgIcon component instead. Example: <TAGSvgIcon icon="arrow_right" size=32 />
 */

var MottoArrowRight = function MottoArrowRight(props) {
  return React.createElement("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M19.4738 0.923587L30.6309 13.7495C32.4564 15.9715 32.4564 15.9715 30.6309 18.193L19.2392 31.2889C18.1718 32.5159 17.7656 32.1281 16.2048 30.3337C14.3491 28.2005 14.3067 28.0722 15.3741 26.8452L22.0998 19.1133H0V12.8292H22.0998L15.6084 5.36682C14.5411 4.13977 14.3493 3.74216 16.2048 1.60883C18.0603 -0.524502 18.4065 -0.303454 19.4738 0.923587Z",
    fill: props.fill
  });
};

export default MottoArrowRight;